import {css} from 'lit-element'; export default css`@media (max-width:677px){:host agentx-wc-agent-performance-reports{min-height:400px}}`;
    